import { RouteObject } from "../../helpers/tixxt-router";
import { lazy, Suspense } from "react";
import Loading from "../shared/Loading";

const AppointmentsPage = lazy(
  () => import("../../components/appointments/AppointmentsPage"),
);
const ManageCalendarsPage = lazy(
  () => import("../../components/appointments/calendars/ManageCalendarsPage"),
);
const SubscribeCalendarsPage = lazy(
  () =>
    import("../../components/appointments/calendars/SubscribeCalendarsPage"),
);
const ParticipantsView = lazy(
  () => import("../../components/appointments/participants/ParticipantsView"),
);
const NewCalendarPage = lazy(
  () => import("../../components/appointments/calendars/NewCalendarPage"),
);
const EditCalendarPage = lazy(
  () => import("../../components/appointments/calendars/EditCalendarPage"),
);
const AppointmentNewPage = lazy(
  () => import("../../components/appointments/AppointmentNewPage"),
);
const AppointmentEditPage = lazy(
  () => import("../../components/appointments/AppointmentEditPage"),
);
const AppointmentPage = lazy(
  () => import("../../components/appointments/AppointmentPage"),
);
const AppointmentContactPage = lazy(
  () => import("../../components/appointments/AppointmentContactPage"),
);
const Invites = lazy(() => import("../../components/appointments/InvitesPage"));

const routes: RouteObject[] = [
  {
    path: "/groups/:groupSlug/calendars",
    element: (
      <Suspense fallback={<Loading />}>
        <AppointmentsPage />
      </Suspense>
    ),
  },
  {
    path: "/appointments",
    element: (
      <Suspense fallback={<Loading />}>
        <AppointmentsPage />
      </Suspense>
    ),
  },
  {
    path: "/appointments/new",
    element: (
      <Suspense fallback={<Loading />}>
        <AppointmentNewPage />
      </Suspense>
    ),
  },
  {
    path: "/appointments/:id/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <AppointmentEditPage />
      </Suspense>
    ),
  },
  {
    path: "/appointments/participating",
    element: (
      <Suspense fallback={<Loading />}>
        <AppointmentsPage participating />
      </Suspense>
    ),
  },
  {
    path: "/appointments/invites",
    element: (
      <Suspense fallback={<Loading />}>
        <Invites />
      </Suspense>
    ),
  },
  {
    path: "/appointments/:id",
    element: (
      <Suspense fallback={<Loading />}>
        <AppointmentPage />
      </Suspense>
    ),
  },
  {
    path: "/calendars/manage",
    element: (
      <Suspense fallback={<Loading />}>
        <ManageCalendarsPage />
      </Suspense>
    ),
  },
  {
    path: "/calendars/subscribe",
    element: (
      <Suspense fallback={<Loading />}>
        <SubscribeCalendarsPage />
      </Suspense>
    ),
  },
  {
    path: "/calendars/new",
    element: (
      <Suspense fallback={<Loading />}>
        <NewCalendarPage />
      </Suspense>
    ),
  },
  {
    path: "/calendars/:id/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <EditCalendarPage />
      </Suspense>
    ),
  },
  {
    path: "/appointments/:id/participants",
    element: (
      <Suspense fallback={<Loading />}>
        <ParticipantsView />
      </Suspense>
    ),
  },
  {
    path: "/appointments/:id/contact",
    element: (
      <Suspense fallback={<Loading />}>
        <AppointmentContactPage />
      </Suspense>
    ),
  },
];

export default routes;
